import { GenericUpload } from "@nova/constants"
import { get } from "nodash"

export const getObliqueIds = (uploads: { id: string; pitch?: number }[]) => {
    return uploads
        .filter((upload) => upload.pitch !== undefined && upload.pitch > -75)
        .map((upload) => upload.id)
}

export const getZoomedIds = (uploads: GenericUpload[]) => {
    let maxTotalFOV = 0
    uploads.forEach((upload) => {
        const fovArray = get(upload, "fov", [])
        const [fov1, fov2] = fovArray
        if (!fov1 || !fov2) return
        const totalFov = fov1 + fov2
        if (totalFov > maxTotalFOV) maxTotalFOV = totalFov
    })
    const zoomedIds: string[] = []
    uploads.forEach((upload) => {
        const fovArray = get(upload, "fov", [])
        const [fov1, fov2] = fovArray
        if (!fov1 || !fov2) return
        const totalFov = fov1 + fov2
        //if the uploads fov is less than a third of the max fov we found, we considered it zoomed
        if (totalFov * 3 < maxTotalFOV) zoomedIds.push(upload.id)
    })
    return zoomedIds
}

export const getNoLocationIds = (uploads: GenericUpload[]) => {
    return uploads
        .filter((upload) => {
            const lat = get(upload, "latitude")
            const long = get(upload, "longitude")
            return !lat || !long
        })
        .map((upload) => upload.id)
}

export const getThermalDataIds = (uploads: GenericUpload[]) => {
    return uploads
        .filter((upload) => {
            const hasThermalData =
                get(upload, "hasThermalData") || (upload.imageHeight || 10000) <= 1024
            return !!hasThermalData
        })
        .map((upload) => upload.id)
}

export const getNoThermalDataIds = (uploads: GenericUpload[]) => {
    return uploads
        .filter((upload) => {
            const hasThermalData =
                get(upload, "hasThermalData") || (upload.imageHeight || 10000) <= 1024
            return !hasThermalData
        })
        .map((upload) => upload.id)
}
